"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (props, propTypes) => {
    props = { ...props };
    const ownProps = {};
    Object.keys(props).forEach(key => {
        if (key in propTypes) {
            ownProps[key] = props[key];
            delete props[key];
        }
    });
    return [ownProps, props];
};
//# sourceMappingURL=splitProps.js.map